import type { ReactNode } from "react";

import { Link } from "metabase/common/components/Link";
import { Box, Flex } from "metabase/ui";

import S from "./AdminNavbar.module.css";

interface AdminNavLinkProps {
  to: string;
  isSelected?: boolean;
  isInMobileNav?: boolean;
  children?: ReactNode;
}

export const AdminNavLink = ({
  to,
  isSelected,
  isInMobileNav,
  children,
}: AdminNavLinkProps) => (
  <Box
    component={Link}
    to={to}
    className={S.AdminNavLink}
    data-selected={isSelected || undefined}
    bg={isSelected ? "navbar-admin-inverse" : undefined}
    style={{ overflow: isInMobileNav ? "visible" : "hidden" }}
  >
    {children}
  </Box>
);

interface AdminNavListItemProps {
  children?: ReactNode;
}

export const AdminNavListItem = ({ children }: AdminNavListItemProps) => (
  <Flex
    component="li"
    display="inline-flex"
    justify="center"
    // Every item keeps a floor at its own natural (fit-content) width — this
    // used to be removed (min-width: 0) for every non-active item, which let
    // an unopposed flex-shrink squeeze inactive labels down to 1-2 characters
    // plus an ellipsis whenever the row didn't have enough room (e.g. under
    // browser zoom, WCAG 1.4.4). The row now scrolls horizontally instead if
    // it doesn't fit — see the overflow-x on the <ul> in AdminNavbar.tsx.
    miw="fit-content"
    style={{ whiteSpace: "nowrap" }}
  >
    {children}
  </Flex>
);
